// Google Ads conversion tracking — send_to values provided by get_google_ads_conversion_tag
const PHONE_CALL_SEND_TO = "AW-18399904134/ISGxCPvP0-QcEIaD4cVE";
const BOOK_APPOINTMENT_SEND_TO = "AW-18399904134/KD9kCJL2xeQcEIaD4cVE";

export function trackPhoneCallLead() {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "conversion", { send_to: PHONE_CALL_SEND_TO });
  }
}

export function trackBookAppointment(id) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "conversion", {
      send_to: BOOK_APPOINTMENT_SEND_TO,
      currency: "USD",
      ...(id ? { transaction_id: id } : {}),
    });
  }
}